module.exports = __webpack_public_path__ + "static/media/1.b9c4ff1e.png";